import 'nprogress/nprogress.css'; // 引入进度条的样式

import NProgress from 'nprogress'; // 引入进度条功能
import { MessagePlugin } from 'tdesign-vue-next'; // 引入消息插件

import router from '@/router'; // 引入路由实例
import { getPermissionStore, useUserStore } from '@/store'; // 引入权限和用户状态管理

NProgress.configure({ showSpinner: false }); // 配置进度条，不显示加载图标

// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  NProgress.start(); // 开始显示进度条

  const permissionStore = getPermissionStore(); // 获取权限状态管理
  const { whiteListRouters } = permissionStore; // 获取白名单路由
  const userStore = useUserStore(); // 获取用户状态管理

  // 如果用户已登录
  if (userStore.token) {
    // 如果目标路由是登录页 首页 申请页，直接跳转
    if (to.path === '/login' || to.path === '/index' || to.path === '/apply') {
      next();
      return;
    }
    try {
      if (!permissionStore.initialized) {
        // 获取用户信息并初始化路由，只在首次进入系统时执行一次
        await userStore.getUserInfo();
        await permissionStore.initRoutes(userStore.roles || ['all']);
      }

      // 如果路由已注册，直接跳转
      if (router.hasRoute(to.name)) {
        next();
      } else {
        // 如果路由未注册，跳转到默认页面
        next(`/dashboard`);
      }
    } catch (error) {
      // 捕获错误并显示错误消息，跳转到登录页面
      MessagePlugin.error(error.message);
      next({
        path: '/login',
        query: { redirect: encodeURIComponent(to.fullPath) },
      });
      NProgress.done(); // 完成进度条
    }
  } else {
    // 如果用户未登录，检查是否是白名单中的路由
    if (whiteListRouters.indexOf(to.path) !== -1) {
      next(); // 白名单路由直接访问
    } else {
      // 非白名单路由跳转
      next({
        path: '/login',
        query: { redirect: encodeURIComponent(to.fullPath) },
      });
    }
    NProgress.done(); // 完成进度条
  }
});

// 全局后置守卫
router.afterEach((to) => {
  // 如果跳转到登录页面，执行登出操作（如果需要的话）
  if (to.path === '/login') {
    const userStore = useUserStore(); // 获取用户状态管理
    userStore.logout(); // 清除用户信息
  }
  NProgress.done(); // 完成进度条
});
